export default __webpack_public_path__ + "static/postal-vote-application-cb29f161bba7567de7d1f578815a513d.pdf";